import {Template} from "../../../../../components/template/template.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import React, {useEffect, useState} from "react";

import {useParams} from "react-router";
import InputForm from "../../../../../components/input/input-form.jsx";
import HolidayService from "../../../../../services/web/holiday-service.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {FaPlus} from "react-icons/fa";
import {monthsArrIdx1} from "../utils/holiday-utils.js"

const days = Array.from({ length: 31 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
}));

const months = monthsArrIdx1;

const errorMessages = {
    "name.required": `O campo "Nome" é obrigatório.`,
    "day.required": `O campo "Dia" é obrigatório.`,
    "month.required": `O campo "Mês" é obrigatório.`,
    "name.in.using": "Este \"Nome\" já está sendo utilizado.",
    "invalid.date": "Data inválida.",
}

const initialHoliday = {
    day: null,
    month: "",
    name: ""
}

const HolidayForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const {id} = useParams();
    const [holiday, setHoliday] = useState(initialHoliday);
    const navigate = navigateHook();

    useEffect(() => {
        if(!id) return;
       const getHoliday = async () => {
           try{
               setIsLoading(true);
               const { data } = await HolidayService.getById(id)
               setHoliday(data);
           }
           catch(error) {
               console.error(error);
           }
           finally {
               setIsLoading(false);
           }
       }

       getHoliday();
    }, [id]);

    const save = async (addNew = false) => {
        try {
            setIsLoading(true);
            let response;

            if (id) {
                response = await HolidayService.update(holiday);
            } else {
                response = await HolidayService.save(holiday);
            }

            if(addNew){
                projectUtils.success(Boolean(id));
                setHoliday(initialHoliday);
                navigate(`/holiday/form`, false);
                return;
            }

            if(!id) {
                projectUtils.success(true);
                navigate(`/holiday/form/${response.data}`, false);

            } else {
                projectUtils.success(false);
            }


        } catch (error) {
            console.error(error);
            let message = 'Não foi possível salvar.';
            if (error.response?.status !== 500) {
                message = errorMessages[error.response?.data];
            }
            projectUtils.swalErrorMessage('', message, 'Ok');
        }
        finally {
            setIsLoading(false);
        }
    };

    const openForm = () => {
        navigate(`/holiday/form`, false);
        setHoliday(initialHoliday)
    }

    const deleteHoliday = () => {
        if(!id) return;

        try {
            projectUtils.swalMessage(
                'warning',
                'Excluir',
                `Excluir o feriado "${holiday.name}"?`,
                'Sim',
                true,
                'Não',
                async (result) => {
                    if(result.isConfirmed) {
                        try{
                            await HolidayService.delete(id);
                            projectUtils.success(false, "Excluído com sucesso");
                            navigate("/holiday", false);
                        }
                        catch(error){
                            projectUtils.swalErrorMessage('', "Não foi possível excluir", 'Ok');
                            navigate("/holiday", false);
                        }
                    }
                }
            );

        }
        catch(error){
            console.error(error);
            projectUtils.swalErrorMessage('', "Não foi possível excluir", 'Ok');
        }
    }

    return(
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Feriado</Template.Title>
                {   id &&
                    <Button onClick={openForm} target="primary-outline"><FaPlus/> Adicionar feriado</Button>
                }
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Body className="flex gap-2">
                        <div className="flex-1">
                            <SelectComponent
                                id="day"
                                options={days}
                                label={"Dia *"}
                                value={days.find(option => option.value === String(holiday.day)) || null}
                                onChange={(selected) => setHoliday(prev => ({...prev, day: selected?.value ?? null}))}
                            />
                        </div>
                        <div className="flex-1">
                            <SelectComponent
                                id="month"
                                options={months}
                                label={"Mês *"}
                                value={months.find(el => el.value === String(holiday.month)) || null}
                                onChange={(selected) => setHoliday(prev => ({...prev, month: selected?.value ?? null}))}
                            />
                        </div>
                        <div className="flex-5">
                            <InputForm id="name" label="Nome *" value={holiday.name} onChange={({target}) => setHoliday(prev => ({...prev, name: target.value}))}></InputForm>
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mt-2">
                    <Card.Body className="flex justify-end gap-2">
                        {
                            !!id &&
                            <Button target="danger" onClick={deleteHoliday} actionFeedbackType='delete'>Excluir</Button>
                        }
                        <Button target="outline-primary" onClick={() => save(true)} actionFeedbackType='save'>Salvar e adicionar novo</Button>
                        <Button onClick={() => save()} actionFeedbackType='save'>Salvar</Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default HolidayForm;